import * as style from './styles.module.css';

export const PremiumStarIcon = () => {
  return <div className={style.premiumStar} />;
};
